// components/featured.js
'use client';

import { Skeleton, Flex, Input, Carousel, Typography } from 'antd'
import { CameraOutlined, HomeOutlined } from "@ant-design/icons";
import Image from 'next/image'
import { useRef, useMemo, useState, useEffect } from 'react';
import FeaturedHeader from './featured_header';

const { Paragraph } = Typography;

export default function Featured({ subCate }) {

    const [slidesToShow, setSlidesToShow] = useState(8)

    useEffect(() => {
        setSlidesToShow(window.innerWidth < 1580 ? 6 : 8)
    }, [])

    const carouselRef = useRef(null);

    const handleToSearch = (item) => {
        window.open(`/search?catId=${item.id}&searchKey=${item.name}`, '_blank');
    }


    return (

        <div className='featured '>
            <div className='box_warp featured_warp'>

                <FeaturedHeader />

                <div className="carousel-wrapper">

                    <Image
                        src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_lf_arrow.png"
                        alt="Previous"
                        width={53}
                        height={53}
                        className="navigation-btn prev"
                        onClick={() => carouselRef.current.prev()}
                        aria-label="Previous slide"
                    />

                    <Carousel
                        ref={carouselRef}
                        dots={false}
                        infinite
                        speed={500}
                        slidesToShow={slidesToShow}    // 每次滑动一组（包含多行多列）
                        slidesToScroll={5}  // 每次滑动一组
                        rows={2}         // 显示行数
                        slidesPerRow={1} // 每行显示数量
                        centerPadding={"60px"}
                        className="custom-carousel"
                    >
                        {subCate.filter(item => item.icon).map((item, index) => (
                            <div className="carousel-item-box" onClick={() => handleToSearch(item)} key={index}>
                                <div className="carousel-item">
                                    <div className='carousel_item_img_bx'>
                                        <Image
                                            src={item.icon}
                                            alt={item.name}
                                            fill
                                            loading="lazy"
                                            placeholder="blur"
                                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII="
                                        />
                                    </div>
                                    <Paragraph ellipsis={{ rows: 2 }} className="item-name">{item.name}</Paragraph>
                                </div>
                            </div>
                        ))}
                    </Carousel>


                    <Image
                        src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_rt_arrow.png"
                        alt="Next"
                        width={53}
                        height={53}
                        className="navigation-btn next"
                        onClick={() => carouselRef.current.next()}
                        aria-label="Next slide"
                    />
                </div>
            </div>
        </div>

    );
}